import React from "react";
import { ArrowRight } from "@phosphor-icons/react";
import { H } from "./parts";

function Line({ label, children, testId }) {
  return (
    <li className="flex gap-2" data-testid={testId}>
      <ArrowRight size={13} className="text-[#73bf44] shrink-0 mt-0.5" />
      <span><span className="text-neutral-500">{label}:</span> <span className="text-neutral-200">{children}</span></span>
    </li>
  );
}

export function ApprovePlan({ p, needsParts }) {
  const e = p.emails;
  return (
    <div className="border border-neutral-800 bg-black/30 rounded-xl p-4" data-testid="wi-approve-plan">
      <H>When you approve</H>
      <ul className="text-xs space-y-1.5">
        <Line label="Approval number" testId="wi-approve-plan-otma"><b className="font-mono">{p.next_otma || "—"}</b> (next free number, checked on both boards)</Line>
        <Line label="Warranty 2.0">Claim Status set to Approved, the number added, moved to <b>{needsParts ? "Needs Parts" : "Approved"}</b></Line>
        <Line label="Warranty Claims register">New row {p.next_otma} in "Current warranty approvals"{p.register_dealer ? `, dealership ${p.register_dealer}` : ", dealership left blank"}</Line>
        <Line label="Approval email" testId="wi-approve-plan-approval-email">{e.approval_to_valid ? `to ${e.approval_to}` : "no valid dealer email on the claim, so add the address before sending"}</Line>
        {needsParts && <Line label="Parts request email" testId="wi-approve-plan-parts-email">to {e.factory_name ? `${e.factory_name} (${e.factory})` : e.factory}{e.cc ? `, CC ${e.cc}` : ""}, with the claim photos</Line>}
        <Line label="Emails" testId="wi-approve-plan-send-mode">{e.auto_send ? "sent automatically from warranty@ straight away. If a send fails it's retried, then left in Drafts" : "saved as drafts in warranty@. Nothing is sent automatically"}</Line>
        {needsParts && <Line label="Parts Ordered on Monday" testId="wi-approve-plan-parts-ordered">filled in with the date the parts email is sent, and Parts Status set to Ordered (only if it's blank or Not Ordered)</Line>}
      </ul>
    </div>
  );
}
